import type { MessagingConversation } from '../api/messagingApi';

export function sumMessagingUnread(conversations: MessagingConversation[]): number {
  return conversations.reduce((sum, row) => sum + Math.max(0, row.unreadCount || 0), 0);
}

export function sortMessagingInbox(
  conversations: MessagingConversation[],
): MessagingConversation[] {
  return [...conversations].sort((a, b) => {
    const aUnread = a.unreadCount > 0 ? 1 : 0;
    const bUnread = b.unreadCount > 0 ? 1 : 0;
    if (aUnread !== bUnread) {
      return bUnread - aUnread;
    }
    return b.updatedAt - a.updatedAt;
  });
}
